export default "__VITE_ASSET__bf687452__"